import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_SUNRISE = defineFcm('starter_experience_dashboard_sunrise')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_dashboard_sunrise_v1',
		enabled: false,
	})
	.withMerger(({ countryValue, localeValue }) => {
		return { ...countryValue, ...localeValue };
	})
	.toConfig();
